import * as React from "react"
import {useEffect} from "react";
import {useComputed, useSignal} from "@preact/signals-react";
import {CardSeeker, TextFieldSeeker, AlertSeeker} from "@ui-seeker/core";

import {isLoadingCommonFilters} from "@signals";
import { usePriceEvolutionFilters } from "../../@hooks";
import PriceEvolutionTabs from "./Tabs";
import PriceEvolutionTabsSubtitle from "./Subtitle";
import PriceEvolutionTabsLoadingBlock from "./LoadingBlock";
import {PriceEvolutionCurrentTabId, PriceEvolutionCurrentTabLabel} from "../../@signals";



export default function PriceEvolutionTabsBlock() {
    const {
        tabs, isSplitBySku, isPercentage, startDate, endDate, prevStartDate, prevEndDate,
    } = usePriceEvolutionFilters()
    const searchTextField = useSignal('')

    useEffect(() => {
        if (isLoadingCommonFilters.value && searchTextField.value)
            searchTextField.value = ''
    }, [isLoadingCommonFilters.value]);

    const isOpenWarning = useSignal(true)

    const currentTabs = useComputed(() => tabs.filter(tab =>
        tab.id.toString() === PriceEvolutionCurrentTabId.value.toString() || tab.label.toLowerCase().includes(searchTextField.value.toLowerCase()))
    )

    if (isLoadingCommonFilters.value)
        return <PriceEvolutionTabsLoadingBlock />

    if (!tabs.length)
        return <></>

    return <>
        { tabs.length >= 500 && <AlertSeeker
                isOpen={isOpenWarning.value}
                severity="warning"
                controller={() => isOpenWarning.value = !isOpenWarning.value}
                title="Over 500 Skus Found"
                open={true}
                sx={{ mb: 1 }}
		    >
			    Applying filters that return too many SKUs may impact performance. Please narrow down your search criteria to ensure optimal functionality.
		    </AlertSeeker>
        }

        <CardSeeker
            title={`${isSplitBySku ? 'SKU' : 'Retailer'} ${isPercentage ? 'Discount' : 'Price'} Evolution - ${PriceEvolutionCurrentTabLabel.value}`}
            actions={<TextFieldSeeker
                placeholder={`Filter ${isSplitBySku ? 'SKUs' : 'Retailers'}`}
                startIcon="search"
                value={searchTextField.value}
                onChange={e => searchTextField.value = e.target.value}
            />}
            subtitle={<PriceEvolutionTabsSubtitle
                numTabs={tabs.length}
                isSplitBySku={isSplitBySku}
                isPercentage={isPercentage}
                startDate={startDate}
                endDate={endDate}
                prevStartDate={prevStartDate}
                prevEndDate={prevEndDate}
            />}
        >
            <PriceEvolutionTabs
                tabs={(searchTextField.value ? currentTabs.value : tabs) || []}
                isSplitBySku={isSplitBySku}
            />
        </CardSeeker>
    </>
}